import { render, staticRenderFns } from "./EnrollmentCenterTasks.vue?vue&type=template&id=0db09fd0&scoped=true&"
import script from "./EnrollmentCenterTasks.vue?vue&type=script&lang=ts&"
export * from "./EnrollmentCenterTasks.vue?vue&type=script&lang=ts&"
import style0 from "./EnrollmentCenterTasks.vue?vue&type=style&index=0&id=0db09fd0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db09fd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VCardText,VCardTitle,VCol,VRow,VSpacer})
